// import React, { useState } from "react";
// import { CancelAdvanceBookingAssignLockers, openLocker } from "../api/api";
// import { BUTTON_PRIMARY, BUTTON_WARNING } from "../assets/constants/Constants";
// import CustomDialog from "./CustomDialog";
// export default function UpcomingLockersComponent({ locker }) {
//   const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
//   const [selectedLocker, setSelectedLocker] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const[cancelHeader, setCancelHeader] = useState("Cancel Booking?");


//   console.log("UpcomingLockersComponent locker: ", locker);

//   const HandleLockerCancel = (locker) => {
//     setSelectedLocker(locker);
//     setIsCancelDialogOpen(true);
//   };

//   const confirmCancelBooking = async () => {
//     console.log("Selected locker for cancellation:", selectedLocker);
//   try {
//     if (!selectedLocker?.reserve_start) {
//       console.error("Reserve start time missing");
//       return;
//     }

//     const now = new Date();
//     const reserveStart = new Date(selectedLocker.reserve_start);

//     // Difference in milliseconds
//     const diffMs = reserveStart - now;

//     // Convert to hours
//     const diffHours = diffMs / (1000 * 60 * 60);

//     console.log("Hours difference:", diffHours);

//     // ❌ Block if less than 3 hours
//     if (diffHours < 3) {
//       setCancelHeader("Cancellation Not Allowed");
//       alert("You cannot cancel booking within 3 hours of check-in.");
//       console.log("Cancellation blocked: Less than 3 hours to check-in");
//       setIsCancelDialogOpen(false);
//       return;
//     }

//     // ✅ Proceed if >= 3 hours
//     setLoading(true);

//     const requestdata = {
//       transaction_id: selectedLocker.ref_id,
//       cancellation_reason: "Cancelled by user",
//     };

//     const cancelResponse =
//       await CancelAdvanceBookingAssignLockers(requestdata);

//     console.log("Cancel Response:", cancelResponse);

//     setIsCancelDialogOpen(false);
//   } catch (error) {
//     console.error("Cancel failed:", error);
//   } finally {
//     setLoading(false);
//   }
// };
//   const HandleLockerModifier = () => {
//     console.log("calling locker modifier api...");
//   };

// function CancelBookingContent({ locker }) {
//   return (
//     <div className="cancel-booking">
//       <h3 className="cancel-booking__title">
//         {cancelHeader}
//       </h3>

//   <p className="cancel-booking__text">
//     Are you sure you want to cancel booking for{" "}
//     <strong className="cancel-booking__locker">
//       Locker #{locker?.lockerNumber}
//     </strong>
//     ?
//     <br />
//     This action cannot be undone.
//   </p>
// </div>
//   );
// }

//   return (
//     <>
//       <div className="locker-card upcoming">
//         {/* Header */}
//         <div className="top">
//           <div className="title">{locker.name}</div>

//           <div
//             className={`status ${locker.status}`}
//           >
//             {`${locker.status}`}
//           </div>
//         </div>

//         {/* Locker Info */}
//         <div className="sub-text">
//           Locker #{locker.lockerNumber} - {locker.size} size
//         </div>

//         {/* Dates */}
//         <div className="date-section">
//           <div className="date-box">
//             <span className="label">Check-in</span>
//             <span className="value">{locker.checkIn}</span>
//           </div>

//           <div className="date-box">
//             <span className="label">Check-out</span>
//             <span className="value">{locker.checkOut}</span>
//           </div>
//         </div>

//         <hr />

//         <button
//                   className="btn-outline"
//                   onClick={HandleLockerModifier}
//                 >
//                   Modify Booking
//                 </button>

//                 <button
//                   className="btn-outline"
//                   onClick={() => HandleLockerCancel(locker)}
//                 >
//                   Cancel Booking
//             </button>
//       </div>

//       {/* ================= CANCEL CONFIRMATION DIALOG ================= */}
//       <CustomDialog
//         dialogId="cancel-locker-dialog"
//         dialogVisible={isCancelDialogOpen}
//         onClose={() => setIsCancelDialogOpen(false)}
//         handleCancel={() => setIsCancelDialogOpen(false)}
//         handleAccept={confirmCancelBooking}
//         buttonOneTitle="No"
//         buttonTwoTitle={loading ? "Cancelling..." : "Yes, Cancel"}
//         buttonProps={{
//           buttonOne: { type: BUTTON_WARNING },
//           buttonTwo: { type: BUTTON_PRIMARY, disabled: loading },
//         }}
//       >
//         {() => <CancelBookingContent locker={selectedLocker} />}
// </CustomDialog>
//     </>
//   );
// }

import React, { useState } from "react";
import { CancelAdvanceBookingAssignLockers } from "../api/api";
import { BUTTON_PRIMARY, BUTTON_WARNING } from "../assets/constants/Constants";
import CustomDialog from "./CustomDialog";
import ButtonComponent from "./ButtonComponent";

export default function UpcomingLockersComponent({ locker }) {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isBlockedDialogOpen, setIsBlockedDialogOpen] = useState(false); // ✅ NEW
  const [selectedLocker, setSelectedLocker] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Parse date
  const parseCustomDate = (dateString) => {
    if (!dateString) return null;

    const [datePart, timePart] = dateString.split(" at ");
    if (!datePart || !timePart) return null;

    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");

    return new Date(year, month - 1, day, hours, minutes);
  };

  // 👉 Open cancel dialog
  const HandleLockerCancel = (locker) => {
    setSelectedLocker(locker);
    setIsCancelDialogOpen(true);
  };

  // 👉 Confirm Cancel
  const confirmCancelBooking = async () => {
    try {
      const now = new Date();
      const reserveStart = parseCustomDate(selectedLocker?.checkIn);

      if (!reserveStart) return;

      const diffHours = (reserveStart - now) / (1000 * 60 * 60);

      if (diffHours < 3) {
        setIsCancelDialogOpen(false);   
        setIsBlockedDialogOpen(true);
        return;
      }
      setLoading(true);

      const requestdata = {
        transaction_id: selectedLocker.ref_id,
        cancellation_reason: "Cancelled by user",
      };

      await CancelAdvanceBookingAssignLockers(requestdata);

      setIsCancelDialogOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // 👉 First dialog content
  const CancelBookingContent = ({ locker }) => (
    <div>
      <h3>Cancel Booking?</h3>
      <p>
        Are you sure you want to cancel booking for{" "}
        <strong>Locker #{locker?.lockerNumber}</strong>?
      </p>
    </div>
  );

  // 👉 Second dialog content
  const BlockedContent = () => (
    <div>
      <h3>Cancellation Not Allowed</h3>
      <p>You cannot cancel booking within 3 hours of check-in.</p>
    </div>
  );

  return (
    <>
      {/* Locker Card */}
      <div className="locker-card upcoming">
        <div className="top">
          <div className="title">{locker.name}</div>
          <div className={`status ${locker.status}`}>
            {locker.status}
          </div>
        </div>

        <div className="sub-text">
          Locker #{locker.lockerNumber} - {locker.size}
        </div>

        <div className="date-section">
          <div className="date-box">
            <span>Check-in</span>
            <span>{locker.checkIn}</span>
          </div>

          <div className="date-box">
            <span>Check-out</span>
            <span>{locker.checkOut}</span>
          </div>
        </div>

        <hr />

        <div className="button-container">
          <ButtonComponent type={BUTTON_PRIMARY} handleClick={() => HandleLockerCancel(locker)} title="Modify Booking" disabled={loading} />
          <ButtonComponent type={BUTTON_WARNING} handleClick={() => HandleLockerCancel(locker)} title="Cancel Booking" disabled={loading} />
        </div>
      </div>

      {/* ✅ FIRST DIALOG */}
      <CustomDialog
        dialogVisible={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
        handleCancel={() => setIsCancelDialogOpen(false)}
        handleAccept={confirmCancelBooking}
        buttonOneTitle="No"
        buttonTwoTitle={loading ? "Cancelling..." : "Yes, Cancel"}
        buttonProps={{
          buttonOne: { type: BUTTON_WARNING },
          buttonTwo: { type: BUTTON_PRIMARY, disabled: loading },
        }}
      >
        {() => <CancelBookingContent locker={selectedLocker} />}
      </CustomDialog>

      {/* ✅ SECOND DIALOG */}
      <CustomDialog
        dialogVisible={isBlockedDialogOpen}
        onClose={() => setIsBlockedDialogOpen(false)}
        handleCancel={() => setIsBlockedDialogOpen(false)}
        buttonOneTitle="OK"
        buttonProps={{
          buttonOne: { type: BUTTON_PRIMARY },
        }}
      >
        {() => <BlockedContent />}
      </CustomDialog>
    </>
  );
}